import { useEffect } from "react";
import GamgeeCoin from "~/components/price-comparison/gamgee-coin";
import { useCoinUsageStore } from "~/stores/coin-usage-store";

const CoinUsageButton = () => {
  const { usageSummary, isLoading, fetchUserCoinUsage } = useCoinUsageStore();

  // Fetch initial coin usage on mount
  useEffect(() => {
    fetchUserCoinUsage();
  }, [fetchUserCoinUsage]);

  return (
    <button
      type="button"
      className="btn btn-sm btn-soft fixed top-4 z-30 right-10"
    >
      <GamgeeCoin size={20} />
      {isLoading ? (
        <span className="loading loading-spinner loading-xs"></span>
      ) : (
        <span className="text-md font-semibold">
          {usageSummary?.monthly_coin_limit?.toLocaleString() || "0"}
        </span>
      )}
    </button>
  );
};

export default CoinUsageButton;
